// Each time you update change to the latest
// date of updating. Also change your facilitator
// instituion name. Change here will affect whole application.

let facilitatorInstituionName = "Facilitator Team - AutoDapp"
let facilitatorLastUpdated = "29th AUGUST 2024"

export { facilitatorInstituionName, facilitatorLastUpdated }